export default __webpack_public_path__ + "static/media/icon-eclaim-list.bacffda7.svg";